module.exports = __webpack_public_path__ + "img/bg-program.be20ffe0.svg";